import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig } from '@spartacus/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { provideDefaultConfig } from '../../../core/config';
import { I18nModule } from '../../../core/i18n';
import { CmsPuffCollectionContentTagsModule, GenericLinkModule, MediaModule, ReadMoreModule } from '../../../shared';
import { PublishedDateModule } from '../../../shared/components/published-date/published-date.module';
import { PuffComponent } from './puff.component';

@NgModule({
  imports: [
    CommonModule,
    MediaModule,
    I18nModule,
    GenericLinkModule,
    NzIconModule,
    CmsPuffCollectionContentTagsModule,
    PublishedDateModule,
    ReadMoreModule,
  ],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        PuffComponent: {
          component: PuffComponent,
        },
      },
    }),
  ],
  declarations: [PuffComponent],
  exports: [PuffComponent],
})
export class CmsPuffModule {}
